'use strict';
/* global angular */

angular.module('atex.aceui.service').factory('SecurityUserService',
  ['$q', '$rootScope', 'AuthenticationService', 'ApplicationConfigurationService',

    function ($q, $rootScope, AuthenticationService, ApplicationConfigurationService) {
      var serviceHandler = undefined;

      var handler = function () {
        if (serviceHandler !== undefined) {
          return $q.when(serviceHandler);
        }

        return ApplicationConfigurationService.getServiceConfigurationFor('SecurityUserService')
          .then(function (configuration) {
            var serviceUrl = atex.aceui.ServiceUtils.calculateServiceUrl(configuration, 'security/user');

            var serviceSettings = { customQ: atex.aceui.AngularUtils.applyingQ($q, $rootScope), cacheBusting: atex.aceui.BrowserUtils.isSafariBrowser() };
            serviceHandler = atex.aceui.service.SecurityUserService(serviceUrl, serviceSettings);

            return serviceHandler;
          });
      };

      return {
        /**
         * Wraps atex.aceui.service.SecurityUserService.search with an authentication
         * guard (provided by AuthenticationService.callWithAuthentication).
         *
         * See documentation for atex.aceui.service.SecurityUserService.search
         * See documentation for AuthenticationService.callWithAuthentication
         */
        search: function ({ query }) {
          return AuthenticationService.callWithAuthentication(function (currentUser) {
            return handler().then(function (serviceHandler) {
              return serviceHandler.search({ querystring: query, token: currentUser.token });
            });
          });
        }
      };
    }
  ]);
